import { BoxProps } from '@jfs/ui-new'

export const styles = {
  navItem: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    paddingVertical: 24,
    backgroundColor: 'WHITE',
  } as BoxProps,
}
